module.exports = __webpack_public_path__ + "static/media/icon-time.67a55286.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-time.svg
// module id = ./src/assets/images/icon-time.svg
// module chunks = 6